import { parseBool, webStorage } from 'sidecar-utility-library'

import { isActionRelevant } from './utils'
import { fetchApplicants } from 'store/Applicant'

/** Saves the token to webStorage */
export default ({ dispatch }) =>
  next =>
  action => {
    if (!isActionRelevant(action, /FETCH_ACCOUNT_METADATA_SUCCESS/))
      return next(action)

    const { payload: { hasPolicy = false } = {} } = action

    // the fetchAccountMetaData call will be made shortly after a LOGIN_SUCCESS
    // found in src/components/_common/LoginForm/enhance.js
    // there are many scenarios that a user can go to dashboard or account if
    // they have yet to finish a flow. we want to make sure we account for those
    // scenarios or if they tried to signup in a non covered state as well
    // Because we deprecated hasPurchased from v1/login?type=password to hasPolicy
    // inside v1/accounts/${uuid}/account-metadata, we want to wait on the fetches
    // until the accountMetaData response is successful
    webStorage.setItem('hasPolicy', hasPolicy)
    const justRegistered = parseBool(webStorage.getItem('justRegistered'))
    if (!justRegistered) {
      dispatch(fetchApplicants())
    }
    webStorage.setItem('justRegistered', false)

    return next(action)
  }
